export enum OrderType {
    Accending = "Accending",
    Deccending = "Deccending"
}